module.exports = __webpack_public_path__ + "img/back.913a55ae.png";